import {Texture} from 'pixi.js';
import {lifeResourceArt,loadLifeArt} from './life-skill-art';

const textures=new Map<string,Texture>();
const pending=new Set<string>();
const retryAfter=new Map<string,number>();

/** Keep source alpha and dark outlines. No color-key background removal. */
export function lifeWorldTexture(graphic:string,now:number,frameOverride?:number):Texture|undefined{
  const base=lifeResourceArt[graphic];if(!base)return;
  const animated=graphic==='campfire'||graphic==='fishing_spot';
  const frame=frameOverride??(animated?Math.floor(now/250)%base.frames:base.frame);
  const key=`${graphic}:${frame}`;
  const ready=textures.get(key);if(ready)return ready;
  if(pending.has(key)||(retryAfter.get(key)??0)>now)return;
  pending.add(key);
  void loadLifeArt({...base,frame}).then(canvas=>{
    const texture=Texture.from(canvas);texture.source.scaleMode='nearest';textures.set(key,texture);
  }).catch(()=>retryAfter.set(key,Date.now()+10000)).finally(()=>pending.delete(key));
}
